import Box from "@material-ui/core/Box";
import React from "react";
import Fade from "@material-ui/core/Fade";

export function RenderLogoFade ( props ) {
    const { imageUrl, timer, imageHeight } = props;

    if ( imageUrl !== "" ) {
        return (
            <Fade in={imageUrl !== ""} timeout={{ enter: timer }} children={
                <img src={imageUrl} alt={process.env.REACT_APP_MONEY_SITE_NAME} height={imageHeight}/>
            }/>
        );
    } else {
        return (
            <Fade in={true} timeout={{ enter: timer }} children={
                // <img src={process.env.REACT_APP_LOGO_PATH} alt={process.env.REACT_APP_MONEY_SITE_NAME}  height={imageHeight}/>
                <Box style={{ width: 100, height: imageHeight }}/>
            }/>
        );
    }
}